const MessageLoadingState = () => (
  <div class='relative flex ml-2 mb-5 motion-safe:animate-[appear_0.3s_linear]'>
    <div class='w-5 h-5 bg-muted rounded-full motion-safe:animate-ping' />
    <div class='absolute w-5 h-5 bg-muted/80 rounded-full motion-safe:animate-pulse' />
  </div>
)

export default MessageLoadingState
